module.exports = __webpack_public_path__ + "img/plan-duo.eff272bc.png";